import { WIDTH_COLLAPSE_CLOSE, WIDTH_COLLAPSE_OPEN } from 'constants/Desktop';
import styled from 'styled-components';

export const ContentHorizontalOffset = styled.div<{ $isMenuOpen: boolean }>`
  padding-left: ${({ $isMenuOpen }) => ($isMenuOpen ? `${WIDTH_COLLAPSE_OPEN}` : `${WIDTH_COLLAPSE_CLOSE}`)};
`;
